import React from 'react';
import { Link } from 'react-router-dom';
import { usePageLastUpdated } from '../../hooks/usePageLastUpdated';
import '../projects/ProjectPage.css';
import './ResearchDetailPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2012-06-09', displayDate: 'June 9, 2012' };

const PhdMapPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  return (
    <div className="project-page research-detail-page" id="top">
      <h1 className="title">Doctoral Defense Location</h1>
      <p>
        <Link to="/research/phd">← Back to defense page</Link>
      </p>
      <p>Aula de Grados, Padre Soler Building, Leganés Campus, Universidad Carlos III de Madrid</p>
      <p>
        <a href="https://www.google.com/maps?q=40.332513,-3.764526" target="_blank" rel="noopener noreferrer" className="external">
          View map on Google Maps
        </a>
      </p>
      <p className="update">Last updated: June 9, 2012</p>
    </div>
  );
};

export default PhdMapPage;
